@if (messageActive()) {
  <div class="alert supo-aim-colour alert-dismissible fade show" role="alert">
    <fa-icon icon="info-circle" size="lg" class="col-1 ml-5"></fa-icon>
    <strong>Warning:</strong>
    @if ('lastpage' === pageType) {
      <span class="col align-self-center">{{aimMessageLastPage.message}}</span>
    }
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="setDisplayInfoBox()">
      <fa-icon icon="times" class="col-1 ml-5"></fa-icon>
    </button>
  </div>
}
